import React, { useRef } from 'react';
import { Autocomplete } from '@react-google-maps/api';

/**
 * A single Google Places autocomplete field that emits a normalized
 * place object via `placeFromGoogle` (see rideConfig).
 */
const LocationInput = ({
  placeholder = 'Search a place',
  value = '',
  onChange,
  onSelect,
  icon = 'bi-geo-alt',
  autoFocus = false,
  id,
  className = '',
}) => {
  const ref = useRef(null);

  const handlePlaceChanged = () => {
    const place = ref.current?.getPlace?.();
    if (place && onSelect) onSelect(place);
  };

  return (
    <Autocomplete
      ref={ref}
      onLoad={(ac) => { ref.current = ac; }}
      onPlaceChanged={handlePlaceChanged}
      options={{
        fields: ['formatted_address', 'geometry', 'name', 'address_components'],
        componentRestrictions: { country: 'pk' },
      }}
    >
      <div className={`ride-endpoint-row ${className}`}>
        <i className={`bi ${icon}`} style={{ color: 'var(--ride-muted)', fontSize: '1rem', flexShrink: 0 }} />
        <input
          id={id}
          className="ride-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          autoFocus={autoFocus}
          autoComplete="off"
        />
      </div>
    </Autocomplete>
  );
};

export default LocationInput;
